import $ from "jquery";
import Switchery from "../../lib/switchery/switchery";
import collectDataAttributesFor from "../collectDataAttributesFor";

export function instantiateSwitchery(els, jsOpts={}){
  const res = [];
  var clsName=getAdditionalFieldsClass(els); 
  els.each(function(){
    const el = $(this);
    if(!el.data(clsName)){
      let options = collectDataAttributesFor(el.get(0), {prefix: clsName});
      options = $.extend({}, options, jsOpts);
      const sw = Switchery(this, options);
      el.data(clsName, sw);
    }
    res.push(el.data(clsName));
  });
  return res;
};

function getAdditionalFieldsClass(els){
	 var clsName;
	  els.each(function(){
		  const ele = $(this);
		  for (var i = 0; i < ele.length; i++) {
			  var clssName=ele[i].className;
			if(clssName.includes("reference-show-field-switchery")){
				clsName="reference-show-field-switchery";
			}else if(clssName.includes("department-show-field-switchery")){
				clsName="department-show-field-switchery";
			}else if(clssName.includes("po-show-field-switchery")){
				clsName="po-show-field-switchery";
			}else if(clssName.includes("invoice-show-field-switchery")){
				clsName="invoice-show-field-switchery";
			}else if(clssName.includes("reference-required-field-switchery")){
				clsName="reference-required-field-switchery";
			}else if(clssName.includes("reference-custom-label-switchery")){
				clsName="reference-custom-label-switchery";
			}else if(clssName.includes("department-required-field-switchery")){
				clsName="department-required-field-switchery";
			}else if(clssName.includes("department-custom-label-switchery")){
				clsName="department-custom-label-switchery";
			}else if(clssName.includes("po-required-field-switchery")){
				clsName="po-required-field-switchery";
			}else if(clssName.includes("po-custom-label-switchery")){
				clsName="po-custom-label-switchery";
			}else if(clssName.includes("invoice-required-field-switchery")){
				clsName="invoice-required-field-switchery";
			}else if(clssName.includes("invoice-custom-label-switchery")){
				clsName="invoice-custom-label-switchery";
			}else{
				clsName="js-switchery";
			}
		}
		  
	  });
	  return clsName;
}


export function setSwitchery(switchElement, checkedBool) {
	var clsName=getAdditionalFieldsClass(switchElement); 
	if(switchElement instanceof $){
		switchElement = switchElement.data(clsName);
	}

	if((checkedBool && !switchElement.isChecked()) || (!checkedBool && switchElement.isChecked())) {
		switchElement.setPosition(true);
		switchElement.handleOnchange(true);
	}
};

export function setSwitcheryWithoutChange(switchElement, checkedBool) {
   var clsName=getAdditionalFieldsClass(switchElement); 
  if(switchElement instanceof $){
    switchElement = switchElement.data(clsName);
  }

  if((checkedBool && !switchElement.isChecked()) || (!checkedBool && switchElement.isChecked())) {
    switchElement.setPosition(true);
  }
};

export function enableSwitchery(switchElement) {
  var clsName=getAdditionalFieldsClass(switchElement); 
  if (switchElement instanceof $) {
    switchElement = switchElement.data(clsName);
  }
  switchElement.enable();
};

export function disableSwitchery(switchElement) {
  var clsName=getAdditionalFieldsClass(switchElement); 
  if (switchElement instanceof $) {
    switchElement = switchElement.data(clsName);
  }
  switchElement.disable();
};


// WEBPACK FOOTER //
// ./src/utilities/instantiateSwitchery/index.js